import { ContentSocialType } from '~/api/contents';
import { CarouselVariant } from '~/components/carousel';

export const socialTypeCarousel = {
  [ContentSocialType.INSTAGRAM]: CarouselVariant.SLIDER,
  [ContentSocialType.FACEBOOK]: CarouselVariant.GRID,
  [ContentSocialType.LINKEDIN]: CarouselVariant.SLIDER,
};
